import { Checkbox } from "antd";
import React, { useState } from "react";

const NomineeCard = ({ nominee, isSelected, onSelect }) => {
  return (
    <div
      className={`ant-card ant-card-bordered p1 nominee-card ${
        isSelected ? "border-success" : ""
      } mb-3`}
    >
      <div className="card-body">
        <div className="form-check mb-3">
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelect(e.target.checked ? nominee.id : "")}
          />
        </div>
        <div className="nominee-details">
          <div>
            <strong>Nominee First Name</strong>
            <p>{nominee.firstName}</p>
          </div>
          <div>
            <strong>Nominee Middle Name</strong>
            <p>{nominee.middleName}</p>
          </div>
          <div>
            <strong>Nominee Last Name</strong>
            <p>{nominee.lastName}</p>
          </div>
          <div>
            <strong>Gender</strong>
            <p>{nominee.gender}</p>
          </div>
          <div>
            <strong>Date of Birth</strong>
            <p>{nominee.dob}</p>
          </div>
          <div>
            <strong>Relation to Applicant</strong>
            <p>{nominee.relation}</p>
          </div>
          <div>
            <strong>Address</strong>
            <p>{nominee.address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const NomineeList = () => {
  const [selectedNominee, setSelectedNominee] = useState(null);

  const nominees = [
    {
      id: 1,
      firstName: "KOLA",
      middleName: "NAGA MANI",
      lastName: "-",
      gender: "Female",
      dob: "08/08/1992",
      relation: "Spouse",
      address:
        "Jeevan Building, Street 4, Kakaityaa Hills, Hitech city Hyderabad, Telegana - 500044",
    },
    {
      id: 2,
      firstName: "KOLA",
      middleName: "VISHNU VARUN",
      lastName: "KUMAR",
      gender: "Male",
      dob: "13/04/2005",
      relation: "Son",
      address:
        "Jeevan Building, Street 4, Kakaityaa Hills, Hitech city Hyderabad, Telegana - 500044",
    },
  ];

  const handleSelectNominee = (id) => {
    setSelectedNominee(id);
  };

  return (
    <div>
      {nominees.map((nominee) => (
        <NomineeCard
          key={nominee.id}
          nominee={nominee}
          isSelected={selectedNominee === nominee.id}
          onSelect={handleSelectNominee}
        />
      ))}
    </div>
  );
};

export default NomineeList;
